<template>
    <div>
        <template v-if="sponsor.advanced">
            <v-card height="100%" width="100%" @click="dialog=true" elevation="0">
                <v-img :src="sponsor.file" max-width="100%" aspect-ratio="2"
                       contain>
                    <v-row justify="center" align="center" class="fill-height" v-if="!sponsor.file">
                        <v-col cols="auto">
                            <v-icon style="font-size: 80px">mdi-image-off-outline</v-icon>
                        </v-col>
                    </v-row>
                </v-img>
              <v-card-title v-if="showName">{{ sponsor.name }}</v-card-title>
            </v-card>
            <v-dialog v-model="dialog">
                <v-card>
                    <v-row justify="center" no-gutters>
                        <v-col>
                            <v-img :src="sponsor.file" max-height="300px" contain>
                                <v-btn icon @click="dialog=false" absolute top right color="primary">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </v-img>
                        </v-col>
                    </v-row>
                    <v-card-title>{{ sponsor.name }}</v-card-title>
                    <v-card-text v-html="sponsor.description" v-if="sponsor.description"></v-card-text>
                    <v-card-title>{{sponsor.downloads_heading ? sponsor.downloads_heading : $t('sponsor.downloads_heading')}}</v-card-title>
                    <v-card-text v-if="sponsor.downloads && sponsor.downloads.length>0">
                        <v-list dense>
                            <template v-for="(download, idx) in sponsor.downloads">
                                <v-list-item :href="download.file" :key="idx" target="_blank">
                                    <v-list-item-action>
                                        <v-icon>{{fileIcon(download.file)}}</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ download.name }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider v-if="idx<sponsor.downloads.length-1"
                                           :key="`d+${idx}`"></v-divider>
                            </template>
                        </v-list>
                    </v-card-text>
                    <v-card-title>{{sponsor.contacts_heading ? sponsor.contacts_heading : $t('sponsor.contacts_heading')}}</v-card-title>
                    <v-card-text v-if="sponsor.contacts && sponsor.contacts.length>0" class="text-body-2">
                            <template  v-for="(contact, idx) in sponsor.contacts">
                                <div v-if="contact.text || contact.heading" :key="idx" style="color: rgba(0,0,0,0.87)">
                                    <span v-if="contact.heading" v-html="contact.heading" class="py-2"></span>
                                    <span v-if="contact.heading && contact.text">: </span>
                                    <span v-if="contact.text" v-html="contact.text" class="py-2"></span>
                                </div>
                            </template>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </template>
        <v-card v-else height="100%" width="100%" :href="sponsor.link" elevation="0" target="_blank">
            <v-img :src="sponsor.file" max-width="100%" aspect-ratio="2"
                   contain>
                <v-row justify="center" align="center" class="fill-height" v-if="!sponsor.file">
                    <v-col cols="auto">
                        <v-icon style="font-size: 80px">mdi-image-off-outline</v-icon>
                    </v-col>
                </v-row>
            </v-img>
            <v-card-title v-if="showName">{{ sponsor.name }}</v-card-title>
        </v-card>
    </div>
</template>

<script>
    export default {
        name: 'Sponsor',
        props: {
            sponsor: {
                type: Object,
                default: () => ( {} ),
            },
          showName: {
              type: Boolean,
              default: true,
          }
        },
        data ()
        {
            return {
                dialog: false,
            };
        },
        methods: {
            fileIcon ( url )
            {
                let extension = url.split( '.' ).pop();
                return extension === 'pdf' ? 'mdi-file-pdf-outline' : 'mdi-file-image-outline';
            },
        },
    };
</script>

<style scoped>

</style>